import { filterPermittedLinks } from 'components/NavigationMenu/links';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from 'store/reducers/authReducer';
import { LoginForm } from './LoginForm';
import { LoginPageWrapper } from './style';

function LoginPage() {
  useDocumentTitle('Вход в систему | Payda');
  const dispatch = useDispatch();
  const { isLoading, error, isLoggedIn, user } = useSelector(
    (state) => state.auth
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(getFirstPath());
    }
  }, [isLoggedIn, navigate]);

  const handleLogin = (formValues, captchaToken) => {
    dispatch(login({ ...formValues, captcha_token: captchaToken }));
  };

  const getFirstPath = () => {
    let path = '';

    if (user) {
      const permittedLinks = filterPermittedLinks(user);

      if (permittedLinks.length) {
        const link = permittedLinks[0];

        if (link.sublinks && link.sublinks?.length) {
          path = link.sublinks[0].path;
        } else {
          path = link.path;
        }
      }
    }

    return path;
  };

  return (
    <LoginPageWrapper>
      <div className="logo-section">
        <img src="./assets/icons/logo/payda-lg-white.svg" alt="Payda logo" />
      </div>

      <div className="login-section">
        <LoginForm onSubmit={handleLogin} loading={isLoading} error={error} />
      </div>
    </LoginPageWrapper>
  );
}

export { LoginPage };
